import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalMessageService {
  private tituloSubject = new BehaviorSubject<string>('');
  private parrafoSubject = new BehaviorSubject<string>('');
  private viewModalSubject = new BehaviorSubject<boolean>(false);
  private icoSrcSubject = new BehaviorSubject<string>('');
  private fooSubject = new BehaviorSubject<boolean>(false);

  // Observables
  tituloModal$ = this.tituloSubject.asObservable();
  parrafoModal$ = this.parrafoSubject.asObservable();
  viewModal$ = this.viewModalSubject.asObservable();
  icoSrc$ = this.icoSrcSubject.asObservable();
  foo$ = this.fooSubject.asObservable();

  // Función para abrir el modal con datos personalizados
  openModal(titulo: any, parrafo: any, icoSrc: any, foo: any) {
    this.tituloSubject.next(titulo);
    this.parrafoSubject.next(parrafo);
    this.icoSrcSubject.next(icoSrc);
    this.fooSubject.next(foo);
    this.viewModalSubject.next(true); // Muestra el modal
  }

  // Función para cerrar el modal
  closeModal() {
    this.viewModalSubject.next(false); // Oculta el modal
  }
}
